module.exports = __webpack_public_path__ + "static/media/packing-order.b73301e9.jpg";